<style>
.stepsBar {
  display: flex;
  justify-content: space-between;
  max-width: 70%;
  margin: 0 auto;
  margin-top: 20px;
}
.steps {
  color: #56bae7;
  align-items: center;
  display: flex;
  flex-direction: column;
}
p.active {
  font-weight: bold;
}
hr.verify {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #cfcfcf;
}

.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}
a.stepper-item {
  color: #073763;
}
.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: -50%;
  z-index: 2;
}
.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 2;
}
.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}
.stepper-item.active {
  font-weight: bold;
}
.stepper-item.completed .step-counter {
  background-color: #ccc;
}
.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
}
.stepper-item:first-child::before {
  content: none;
}
.stepper-item:last-child::after {
  content: none;
}
.rejectionBlock {
  text-align: center;
  background-color: #fff;
  padding: 5%;
}
.rejectionBlock img {
  width: 20%;
}
.rejectionBlock h4 {
  font-size: 26px;
  margin-top: 40px;
  margin-bottom: 50px;
}
.rejectionBlock a {
  font-size: 20px;
}
.uploadProof-row {
  background-color: #f3f3f3;
  border: 1px solid #d8d8ef;
  border-radius: 4px;
  position: relative;
  margin-bottom: 20px;
}
.p-3 {
  padding: 1rem !important;
}
.row {
  display: flex;
  flex-wrap: wrap;
}
.valigncenter {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  height: calc(100vh - 140px);
  flex-flow: wrap;
}
.stepsForm-include .col-lg-6 {
  max-width: 1199px;
  margin: 0px auto;
}
.stepBorder h3 {
  font-size: 30px;
  color: #073763;
  margin-bottom: 1.5rem;
  font-weight: normal;
}
.stepsForm-include p {
  font-size: 16px;
  color: #727580;
  margin-bottom: 1.25rem;
}
.oneFive {
  margin-top: 2rem;
}
.uploadProof-row .upload-btn-wrapper {
  width: 140px;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}
.upload-btn-wrapper input[type="file"] {
  position: absolute;
  inset: 0px;
  opacity: 0;
  cursor: pointer;
  border: 2px solid transparent;
  width: 100%;
}
.upload-btn-wrapper .btn {
  border: 2px solid #d8d8ef;
  color: #073763;
  background-color: rgb(255, 255, 255);
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  margin: 0px;
}
.loopUpload .attachmenttSatus {
  position: relative;
  bottom: 0;
  text-align: left;
  border: 1px solid #d8d8ef;
  padding: 2px;
  border-radius: 4px;
  width: 80px;
  height: 80px;
  margin: 0 10px 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loopUpload .attachmenttSatus i.vue-feather {
  background: #d04343;
  width: 30px;
  height: 30px;
  position: relative;
  right: 0;
  top: 0;
  left: 0;
  border-radius: 100%;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;
  color: white;
}
.loopUpload .attachmenttSatus .deletedoc {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  margin: 0 auto;
  align-items: center;
  height: 100%;
  width: 100%;
  background: rgba(0,0,0,.1);
  display: none;
}
.loopUpload .attachmenttSatus:hover .deletedoc, .loopUpload .attachmenttSatus i.feather {
  display: flex;
}
</style>
<template>
  <div class="deposit-live profile-page">
    <div class="stepper-wrapper">
      <a
        @click="() => changeStep(1)"
        class="stepper-item"
        :class="
          store.liveAccounts.length || hasLiveAccount() ? 'completed' : ''
        "
      >
        <div class="step-counter">
          <i
            v-show="store.liveAccounts.length > 0 || hasLiveAccount()"
            class="far fa-check-circle fa-3x"
          ></i>
          <i
            v-show=" store.liveAccounts.length == 0 && !hasLiveAccount()"
            class="far fa-circle fa-3x"
          ></i>
        </div>
        <div class="step-name">
          <p :class="step == 1 ? 'active' : ''">{{$t("corporate_varify.corporation_info")}}</p>
        </div>
      </a>
      <a
        @click="() => changeStep(2)"
        class="stepper-item"
        :class="
          store.liveAccounts.length || hasLiveAccount1() ? 'completed' : ''
        "
      >
        <div class="step-counter">
          <i
            v-show="store.liveAccounts.length > 0 || hasLiveAccount1()"
            class="far fa-check-circle fa-3x"
          ></i>
          <i
            v-show=" store.liveAccounts.length == 0 && !hasLiveAccount1()"
            class="far fa-circle fa-3x"
          ></i>
        </div>
        <div class="step-name">
          <p :class="step == 2 ? 'active' : ''">{{$t("corporate_varify.account_creation")}}</p>
        </div>
      </a>
      <a
        @click="() => changeStep(3)"
        class="stepper-item"
        :class="
          store.liveAccounts.length || hasLiveAccount() ? 'completed' : ''
        "
      >
        <div class="step-counter">
          <i
            v-show="store.liveAccounts.length > 0 || hasLiveAccount()"
            class="far fa-check-circle fa-3x"
          ></i>
          <i
            v-show=" store.liveAccounts.length == 0 && !hasLiveAccount()"
            class="far fa-circle fa-3x"
          ></i>
        </div>
        <div class="step-name">
          <p :class="step == 3 ? 'active' : ''">{{$t("corporate_varify.verification")}}</p>
        </div>
      </a>
      <a
        @click="() => changeStep(4)"
        class="stepper-item"
        :class="hasDeposit() ? 'completed' : ''"
      >
        <div class="step-counter">
          <i v-show="hasDeposit()" class="far fa-check-circle fa-3x"></i>
          <i v-show="!hasDeposit()" class="far fa-circle fa-3x"></i>
        </div>
        <div class="step-name">
          <p :class="step == 4 ? 'active' : ''">{{$t("corporate_varify.deposit")}}</p>
        </div>
      </a>
    </div>
    <hr class="verify" />
    <div
      style="
        min-height: 500px;
        justify-content: center;
        align-items: center;
        max-width: 65%;
        margin: 0 auto;
      "
    >
      <div v-show="step == 1">
        <div class="main-content f-left">
          <CorporationInfo />
        </div>
      </div>
      <div v-show="step == 2">
        <div class="main-content f-left">
          <Form @submit="createAccount">
            <div class="content-holder">
              <div class="row-sec">
                <div class="form-holder wow fadeInLeft">
                  <ul class="clearfix">
                    <li>
                      <label for="">{{$t("corporate_varify.select_platform")}}</label>
                      <Field
                        class="form-control"
                        as="select"
                        name="platform"
                        rules="required"
                        v-model="form.platform"
                        @change="
                          form.currency ? (form.currency = '') : null;
                          form.account_type ? (form.account_type = '') : null;
                        "
                      >
                        <option value="" disabled>{{$t("corporate_varify.select_platform")}}</option>
                        <option
                          v-for="platform of availablePlatforms"
                          :value="platform.value"
                          :key="platform.value"
                        >
                          {{ platform.label }}
                        </option>
                      </Field>
                      <ErrorMessage name="platform" />
                    </li>
                    <li>
                      <label for="">{{$t("corporate_varify.select_account_type")}}</label>
                      <Field
                        class="form-control"
                        as="select"
                        name="type"
                        rules="required"
                        v-model="form.account_type"
                        @change="form.currency?form.currency = '':null"
                      >
                        <option value="" disabled>{{$t("corporate_varify.select_account_type")}}</option>
                        <option
                          v-for="account of availableAccountTypes"
                          :value="account.value"
                          :key="account.value"
                        >
                          {{ account.label }}
                        </option>
                      </Field>
                      <ErrorMessage name="type" />
                    </li>
                    <li
                      v-if="form.account_type != 'ZULU'"
                    ><!-- form.account_type != 'ISL' && -->
                      <label for="">{{$t("corporate_varify.select_leverage")}}</label>
                      <Field
                        class="form-control"
                        as="select"
                        name="leverage"
                        rules="required"
                        v-model="form.leverage"
                      >
                        <option value="" disabled>{{$t("corporate_varify.select_leverage")}}</option>
                        <option
                          v-for="leverage of static_vars.leverages"
                          :value="leverage.value"
                          :key="leverage.value"
                        >
                          {{ leverage.label }}
                        </option>
                      </Field>
                      <ErrorMessage name="leverage" />
                    </li>
                    <li>
                      <label for="">{{$t("corporate_varify.select_base_currency")}}</label>
                      <Field
                        class="form-control"
                        as="select"
                        name="currency"
                        rules="required"
                        v-model="form.currency"
                      >
                        <option value="" disabled>{{$t("corporate_varify.select_currency")}}</option>
                        <option
                          v-for="(value, key) in currencyList()"
                          :value="key"
                          :key="value"
                        >
                          {{ key }}
                        </option>
                      </Field>
                      <ErrorMessage name="currency" />
                    </li>
                    <li>
                      <label for="">{{$t("corporate_varify.password")}}</label>
                      <Field
                        class="form-control"
                        name="password"
                        type="password"
                        rules="required|min:5"
                        v-model="form.password"
                        maxlength="15"
                        @focusin="showPassDiv = true"
                        @focusout="showPassDiv = false"
                      />
                      <ErrorMessage name="password" />
                      <!-- <p><strong>Note: </strong>Minimum 8 character</p> -->
                      <div id="pr-box" class="light" v-show="showPassDiv">
                        <i></i>
                        <div id="pr-box-inner">
                          <p>{{$t("corporate_varify.pass_length_alert")}}</p>
                          <ul>
                            <li class="pr-numcharacters">
                              <span :class="form.password.length >= 5 ? 'pr-ok' : ''"></span>
                              # {{$t("corporate_varify.of_characters")}}
                            </li>
                            <li class="pr-useLowercase">
                              <span :class="lowercaseOK ? 'pr-ok' : ''"></span>
                              {{$t("corporate_varify.lowercase_letter")}}
                            </li>
                            <li class="pr-useUppercase">
                              <span :class="uppercaseOk ? 'pr-ok' : ''"></span>
                              {{$t("corporate_varify.capital_letter")}}
                            </li>
                            <li class="pr-useNumbers">
                              <span :class="numberOk ? 'pr-ok' : ''"></span>
                              {{$t("corporate_varify.number")}}
                            </li>
                            <li class="pr-useSpecial">
                              <span :class="SpecialCharOk ? 'pr-ok' : ''"></span>
                              {{$t("corporate_varify.special_character")}}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li>
                      <label for="">{{$t("corporate_varify.confirm_password")}}</label>
                      <Field
                        class="form-control"
                        name="Confirm Password"
                        type="password"
                        rules="required|min:5|confirmed:@password"
                        v-model="form.confirmPassword"
                        maxlength="15"
                      />
                      <ErrorMessage name="Confirm Password" />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="btn-holder t-center">
              <button type="submit" class="btn btn-yellow popup-link-holder">
                {{$t("corporate_varify.create_account")}}
              </button>
            </div>
          </Form>
        </div>
      </div>
      <div v-show="step == 3">
        <CorporateVerifyStep3 />
      </div>
      <div v-show="step == 4">
        <Deposit />
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import CorporationInfo from "@/views/user/corporation-info";
import CorporateVerifyStep3 from "@/views/user/corporate-verify-step3";
import Deposit from "@/views/funds/deposit";
import { Form, Field, ErrorMessage } from "vee-validate";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      step: 3,
      form: {
        account_type: "",
        demo_live: "1",
        platform: "MT4",
        leverage: "",
        currency: "",
        password: "",
        confirmPassword: "",
        verificationSteps: true,
      },
      showPassDiv: false,
      lowercaseOK: false,
      uppercaseOk: false,
      numberOk: false,
      SpecialCharOk: false
    };
  },
  mounted() {
    // if (this.isVerified()) {
    //   this.changeStep(4);
    // } else if (this.hasLiveAccount()) {
    //   this.changeStep(3);
    // } else if (this.hasDeposit()) {
    //   this.changeStep(2);
    // }else {
    //   this.changeStep(1);
    // }
    // if(this.hasDeposit()) {
    //   this.changeStep(4);
    // } else if (this.hasLiveAccount()) {
    //   this.changeStep(3);
    // } else if (this.hasLiveAccount()) {
    //   this.changeStep(2);
    // }
  },
  watch: {
    "form.password": function (val) {
      let lowerCase = new RegExp("[a-z]"),
        upperCase = new RegExp("[A-Z]"),
        numbers = new RegExp("[0-9]"),
        specialcharacter = new RegExp("[!,%,&,@,#,$,^,*,?,_,~]");
      if (val.match(lowerCase)) {
        this.lowercaseOK = true;
      } else {
        this.lowercaseOK = false;
      }
      if (val.match(upperCase)) {
        this.uppercaseOk = true;
      } else {
        this.uppercaseOk = false;
      }
      if (val.match(numbers)) {
        this.numberOk = true;
      } else {
        this.numberOk = false;
      }
      if (val.match(specialcharacter)) {
        this.SpecialCharOk = true;
      } else {
        this.SpecialCharOk = false;
      }
      if (
        this.lowercaseOK &&
        this.uppercaseOk &&
        this.numberOk &&
        this.SpecialCharOk &&
        val.length >= 5
      ) {
        this.showPassDiv = false;
      }
    },
  },
  computed: {
    availablePlatforms() {
      if (this.form.demo_live == "1") {
        return this.static_vars.platforms;
      } else {
        return this.static_vars.platforms.filter((i) => i.value != "ZTP");
      }
    },
    availableAccountTypes() {
      if (this.form.platform == "MT5") {
        return this.static_vars.accountTypes.filter(
          (i) => i.value != "ZULU"
        );/* i.value != "ISL" &&*/
      } else {
        return this.static_vars.accountTypes;
      }
      /*if (this.form.platform == "ZTP") {
        return this.static_vars.accountTypes.filter(
          (i) => i.value != "ECN" && i.value != "ECNP"
        );
      } else {
        return this.static_vars.accountTypes.filter(
          (i) => i.value == "ECN" || i.value == "ECNP"
        );
      }*/
    },
  },
  components: {
    CorporationInfo,
    CorporateVerifyStep3,
    Deposit,
    Form,
    Field,
    ErrorMessage,
  },
  methods: {
    currencyList() {
      if(this.form.account_type == 'ISL'){
        return this.static_vars.currency_ISL
      } else if (this.form.platform == "MT4") {
        return this.static_vars.currency_mt4;
      } else {
        return this.static_vars.currency;
      }
    },
    hasLiveAccount() {
      if (this.store.liveAccounts.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    hasLiveAccount1() {
      if (this.store.liveAccounts.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    // isVerified() {
    //   if (this.store.user.verified_status) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    hasDeposit() {
      if (this.store.depositsList.records.length) {
        return true;
      } else {
        return false;
      }
    },
    changeStep(step) {
      if (step == 1 && !this.hasLiveAccount()) {
        this.step = step;
      }
      if (step == 2 && !this.hasLiveAccount()) {
        this.step = step;
      }
      if (step == 3 && !this.hasLiveAccount()) {
        this.step = step;
      }
      // if (step == 3 && !this.isVerified()) {
      //   this.step = step;
      //   setTimeout(() => {
      //     this.startIpvNow();
      //   }, 300);
      // }
      if (step == 4 && this.hasLiveAccount()) {
        this.step = step;
      } 
      // else {
      //   this.step = 1;
      // }
    },
    createAccount() {
      let form = JSON.parse(JSON.stringify(this.form));
      /*if (form.account_type == "ISL" || form.account_type == "ZULU") {
        form.leverage = "0";
      }*/
      this.store
        .createAccount(form, true)
        .then(() => {
          if (this.isVerified()) {
            if (!this.hasDeposit()) {
              this.changeStep(4);
            }
          } else {
            this.changeStep(3);
          }
          try{
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event' : 'createaccount',
              'platformType' : form.platform,
              'accountType' : form.account_type,
              'registrationStep' : '2'
            });

            //  live account
            window.dataLayer.push({
              'event' : 'registration',
              'ctaType' : 'LiveAccount',
              'ctaPosition' : window.location.href //this should be replaced with an actual page path/cta button type
            });

          }catch (ex) {
            console.log('ex', ex)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
